export default __webpack_public_path__ + "static/garage_cover-9079efe4886190b30cc56b8b18dfbd23.png";